import "./menu.css";
import { useEffect, useState, useRef } from "react";
import IconButton from "@mui/material/IconButton";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../redux/apiCalls";
import { useDispatch, useSelector } from "react-redux";
import { useCompany } from "../context/CompanyContext";
import { canAccessScreen } from "../../util/accessControl";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";

export default function AccountMenu() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const { accessControl } = useCompany();
  const dispatch = useDispatch();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  function returnPosition() {
    if (currentUser && currentUser.position) {
      return currentUser.position;
    }
    return undefined;
  }

  const menuItems = [
    {
      label: "Configurações",
      icon: <SettingsIcon className="icon" />,
      onClick: () => {
        nav("tabconfigs");
        setOpen(false);
      },
    },
    {
      label: "Importações",
      icon: <FileUploadIcon className="icon" />,
      onClick: () => {
        nav("tabimports");
        setOpen(false);
      },
    },
    {
      label: "Tutorial",
      icon: <OndemandVideoIcon className="icon" />,
      onClick: () => {
        window.open(
          "https://youtube.com/playlist?list=PL9ur2euvOlSzbwPtlEjVYCxMTpRqDdJmk&si=Ker9WUVCqS1syM4f",
          "_blank",
          "noopener,noreferrer",
        );
        setOpen(false);
      },
    },
    {
      label: "Integrações",
      icon: <SettingsIcon className="icon" />,
      onClick: () => {
        nav("integrationerror");
        setOpen(false);
      },
    },
  ];

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleClickLogOff = () => {
    nav(`login`);
    logOut(dispatch);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleToggle}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <Avatar sx={{ width: 32, height: 32 }}>
          {currentUser.name.substring(0, 1).toUpperCase()}
        </Avatar>
      </IconButton>
      <Popper
        style={{ zIndex: 10 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper elevation={3}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                  dense
                  sx={{ py: 0.5, px: 0.5, minWidth: 180 }}
                >
                  <MenuItem
                    className="subMenu"
                    disableRipple
                    sx={{
                      cursor: "default",
                      "&:hover": { background: "none" },
                    }}
                  >
                    <AccountCircleIcon className="icon" />
                    Olá, {currentUser.name}
                  </MenuItem>
                  <Divider sx={{ my: 0.5 }} />

                  {menuItems.map((item) => {
                    if (
                      !canAccessScreen(
                        accessControl,
                        returnPosition(),
                        item.label,
                      )
                    )
                      return null;

                    return (
                      <MenuItem
                        key={item.label}
                        className="subMenu"
                        onClick={item.onClick}
                      >
                        {item.icon}
                        {item.label}
                      </MenuItem>
                    );
                  })}

                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem className="subMenu" onClick={handleClickLogOff}>
                    <LogoutIcon className="icon" />
                    Sair
                  </MenuItem>
                  <label className="label">versão:1.0.3</label>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
